export const primaryColor = "#F61E3B";
export const secondaryColor = "#fff";

export const neutralColor = "#777"
export const background = "#000";
